import { BENEFICIARYDETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  beneficiaryDetailsStatus: undefined,
  beneficiaryDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BENEFICIARYDETAILS.FETCH:
      return {
        ...state,
        beneficiaryDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case BENEFICIARYDETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        beneficiaryDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case BENEFICIARYDETAILS.FAILED:
      return {
        ...state,
        beneficiaryDetailsError: action.payload,
        beneficiaryDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
